import { render } from "./AddTeams.vue?vue&type=template&id=82157162"
import script from "./AddTeams.vue?vue&type=script&lang=js"
export * from "./AddTeams.vue?vue&type=script&lang=js"

import "./AddTeams.vue?vue&type=style&index=0&id=82157162&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__